import { accessControl } from 'lib-shared-access-control';
import { AnyAction, Middleware } from 'redux';

import { AppState } from 'bootstrap.store';
import { presenceActions } from 'components/presence/actions/presenceActions';

export const presenceMiddleware: () => Middleware<unknown, AppState> =
  () => () => {
    return (next) => (action: AnyAction) => {
      switch (action.type) {
        /*
         * presenceSetMedia is not allowed if conversation.reply scope is not available.
         * For all agents without conversation.reply media is disabled by default.
         */
        case presenceActions.presenceSetMedia.toString():
          if (!accessControl.hasAccess('conversation.reply')) {
            break;
          }
          return next(action);
        default:
          return next(action);
      }
    };
  };
